import React from 'react';
import classNames from 'classnames';

import css from './Icon.module.scss';

export type IconType =
  | 'share'
  | 'close'
  | 'arrow-left'
  | 'twitter'
  | 'email'
  | 'facebook'
  | 'whatsapp'
  | 'blue-arrow-right'
  | 'inner-facebook'
  | 'inner-email'
  | 'inner-twitter'
  | 'gallery-close'
  | 'full-screen'
  | 'mark'
  | 'blue-arrow-left';

interface Props {
  type: IconType;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
}

const Icon = ({ type, className, width, height, color = '#000', secondaryColor, ...iconProps }: Props) => {
  let icon = null;
  const svgProps = {
    width,
    height,
    viewBox: `0 0 ${width || 38} ${height || 38}`,
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (type) {
    case 'share':
      icon = (
        <svg {...svgProps} width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.650391" width="34.6996" height="34.6996" rx="10" fill="#053550" />
          <path
            d="M21.901 13.0239H24.2563C25.0596 13.0239 25.7111 13.6622 25.7111 14.4491V25.1589C25.7111 25.9459 25.0596 26.5841 24.2563 26.5841H11.7439C10.9406 26.5841 10.2891 25.9459 10.2891 25.1589V14.4491C10.2891 13.6622 10.9406 13.0239 11.7439 13.0239H14.1179"
            stroke="white"
            strokeWidth="1.6408"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M18 17.5421L18 5.49072"
            stroke="white"
            strokeWidth="1.6408"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M22.0085 9.45758L17.9808 5.52295L13.9531 9.45758"
            stroke="white"
            strokeWidth="1.6408"
            strokeMiterlimit="round"
            strokeLinecap="round"
          />
        </svg>
      );
      break;

    case 'inner-facebook':
      icon = (
        <svg {...svgProps} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.0976562" width="27.8048" height="27.8048" rx="10" fill="#053550" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7426 22.1099H15.1465V14.0453H17.3106C17.419 14.0453 17.5097 13.9628 17.5189 13.8556L17.7271 11.422C17.737 11.3006 17.6411 11.1973 17.5182 11.1973H15.1465V9.47053C15.1465 9.06581 15.4783 8.73774 15.8876 8.73774H17.5557C17.6706 8.73774 17.7646 8.64484 17.7646 8.53116V6.09762C17.7646 5.98328 17.6706 5.89038 17.5557 5.89038H14.7372C13.0835 5.89038 11.7426 7.21564 11.7426 8.85143V11.1973H10.2506C10.135 11.1973 10.041 11.2902 10.041 11.4045V13.838C10.041 13.9524 10.135 14.0453 10.2506 14.0453H11.7426V14.1746V22.1099Z"
            fill="white"
          />
        </svg>
      );
      break;

    case 'inner-twitter':
      icon = (
        <svg {...svgProps} width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.431641" y="0.0976562" width="27.8048" height="27.8048" rx="10" fill="#053550" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1535 20.512C14.8023 20.512 17.0807 18.8232 18.3495 17.4065C19.9381 15.6326 20.8493 13.2863 20.8493 10.9693C20.8493 10.8191 20.846 10.6732 20.8396 10.5359C20.8347 10.4336 20.8826 10.3358 20.967 10.2758C21.345 10.0068 21.6365 9.73957 21.9487 9.40383C22.1412 9.07176 22.2194 8.65135 22.2298 8.45753C22.2403 8.2637 22.2184 7.7497 21.7614 8.03663C21.2784 8.24322 20.7746 8.3978 20.2557 8.49833C20.1515 8.51857 20.0439 8.48457 19.9712 8.40826C19.3664 7.7743 18.5129 7.4107 17.6295 7.4107C15.8605 7.4107 14.4213 8.82685 14.4213 10.5675C14.4213 10.8135 14.4492 11.0557 14.5043 11.2873C14.5265 11.3802 14.503 11.4779 14.4409 11.5511C14.3787 11.6244 14.2848 11.6643 14.1885 11.6598C11.4411 11.5239 8.8568 10.3019 7.02596 8.28836C6.86993 8.66525 6.7887 9.07041 6.7887 9.4803C6.7887 10.5387 7.32231 11.5212 8.21618 12.1083C8.33066 12.1836 8.3807 12.3244 8.33875 12.4534C8.2968 12.5825 8.1734 12.669 8.03547 12.6644C7.61113 12.6516 7.18925 12.5674 6.79233 12.418C6.98209 13.7233 7.99228 14.8027 9.33318 15.0671C9.47351 15.0948 9.57606 15.2138 9.58093 15.3546C9.58573 15.4953 9.49161 15.6208 9.35354 15.6578C8.9682 15.761 8.56957 15.8047 8.16702 15.786C8.69543 16.8212 9.77014 17.5022 10.9752 17.5242C11.1057 17.5266 11.2206 17.6096 11.262 17.7314C11.3035 17.8532 11.2625 17.9875 11.1597 18.0668C9.959 18.9927 8.53659 19.5191 7.02335 19.6014C8.31057 20.1998 9.71756 20.512 11.1535 20.512ZM5.59711 19.5168C5.47618 19.4405 5.4247 19.2921 5.47317 19.1588C5.52156 19.0257 5.65689 18.9426 5.79975 18.9597C6.0619 18.9901 6.33193 19.0055 6.60237 19.0055C7.86992 19.0055 9.07837 18.6695 10.1389 18.0277C8.859 17.7249 7.80424 16.7863 7.39094 15.5168C7.35769 15.4147 7.38161 15.303 7.4538 15.2228C7.52599 15.1426 7.63581 15.1059 7.74275 15.1259C7.80397 15.1375 7.86532 15.1472 7.92675 15.1553C6.84498 14.4806 6.14313 13.2904 6.14313 11.9721C6.14313 11.9514 6.14327 11.9317 6.14437 11.9121C6.14992 11.8074 6.2099 11.713 6.30307 11.6623C6.39623 11.6116 6.50934 11.6117 6.60237 11.6626C6.7392 11.7376 6.88159 11.8024 7.02795 11.8566C6.48048 11.1942 6.17172 10.3592 6.17172 9.4803C6.17172 8.81585 6.35085 8.16158 6.68978 7.58822C6.74071 7.50213 6.83134 7.44606 6.93225 7.43823C7.03295 7.43054 7.1316 7.4719 7.19556 7.54915C8.8457 9.54176 11.247 10.7952 13.8321 11.0265C13.8136 10.8753 13.8043 10.722 13.8043 10.5675C13.8043 8.49206 15.5203 6.80347 17.6295 6.80347C18.624 6.80347 19.5865 7.18994 20.2977 7.8693C20.9923 7.71729 21.6554 7.45861 22.2715 7.09933C22.3816 7.03496 22.5207 7.0444 22.621 7.12301C22.7212 7.20161 22.828 7.31501 22.9032 7.46805C22.9783 7.62109 23.006 7.70445 23.0215 8.17231C23.037 8.64016 22.8278 9.16309 22.7666 9.28143C22.6084 9.58721 22.1252 10.1765 21.4621 10.6707C21.4649 10.7677 21.4662 10.8676 21.4662 10.9693C21.4662 13.4321 20.499 15.9248 18.8123 17.808C17.4595 19.3186 15.0326 21.1193 11.1535 21.1193C9.18058 21.1193 7.25918 20.5651 5.59711 19.5168Z"
            fill="white"
            stroke="white"
            strokeWidth="0.772357"
          />
        </svg>
      );
      break;

    case 'inner-email':
      icon = (
        <svg {...svgProps} width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.861328" y="0.0976562" width="27.8048" height="27.8048" rx="10" fill="#053550" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.1971 12.4608V17.439C21.1971 18.1339 20.8995 18.464 20.254 18.464H9.34134C8.6958 18.464 8.39822 18.1339 8.39822 17.439V12.4799L7.04102 11.349V17.7895C7.04102 18.8911 7.92647 19.7929 9.00915 19.7929H20.52C21.6027 19.7929 22.4882 18.8911 22.4882 17.7895V11.3963L21.1971 12.4608ZM15.4124 13.66C14.9916 13.9037 14.5514 13.9006 14.1044 13.6511L9.45802 9.49126H20.1166L15.4124 13.66ZM13.2317 14.7809C13.2652 14.8109 13.3005 14.8369 13.3389 14.8598C13.8004 15.1373 14.2912 15.2757 14.7774 15.2757C15.2639 15.2757 15.7463 15.1373 16.1907 14.8598C16.2241 14.8392 16.2557 14.8159 16.2853 14.7895L21.5783 10.0995C21.5818 10.096 21.5844 10.0917 21.5886 10.0886L22.2523 9.51575C21.9649 8.75164 21.2651 8.20752 20.4482 8.20752H9.06736C8.26604 8.20752 7.57458 8.72988 7.27693 9.47144L8.19648 10.2729L13.2317 14.7809Z"
            fill="white"
          />
        </svg>
      );
      break;

    case 'gallery-close':
      icon = (
        <svg {...svgProps} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="7.61905" fill="white" />
          <path
            d="M24.381 9.3073L22.6929 7.61914L16.0001 14.3119L9.3073 7.61914L7.61914 9.3073L14.3119 16.0001L7.61914 22.6929L9.3073 24.381L16.0001 17.6883L22.6929 24.381L24.381 22.6929L17.6883 16.0001L24.381 9.3073Z"
            fill="#053550"
          />
        </svg>
      );
      break;

    case 'whatsapp':
      icon = (
        <svg {...svgProps} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.0976562" width="27.8048" height="27.8048" rx="10" fill="#053550" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5588 6H13.465C13.3272 6.04221 13.1852 6.05324 13.0431 6.06429C12.9636 6.07048 12.884 6.07667 12.805 6.08833C11.8506 6.22875 10.9522 6.53333 10.1064 6.99083C8.89736 7.645 7.91085 8.54417 7.17191 9.70625C6.62041 10.5733 6.26054 11.515 6.08729 12.53C5.9491 13.3413 5.92447 14.1546 6.03302 14.9675C6.16202 15.9363 6.45968 16.8554 6.93686 17.7117C7.00408 17.8325 7.01953 17.9358 6.98112 18.0737C6.71018 19.0448 6.44458 20.0171 6.17896 20.9895C6.09627 21.2921 6.01358 21.5948 5.93073 21.8975C5.92155 21.9317 5.91195 21.9658 5.90234 22H5.99711C6.21252 21.9094 6.43867 21.8559 6.66477 21.8025C6.75375 21.7814 6.84272 21.7604 6.93102 21.7371C7.39989 21.6133 7.8692 21.491 8.3385 21.3686C8.89632 21.2232 9.45413 21.0778 10.0112 20.93C10.101 20.9058 10.1682 20.9183 10.2458 20.9592C11.0841 21.4012 11.9742 21.6879 12.9135 21.8046C14.6148 22.0163 16.2279 21.7125 17.7292 20.8896C19.7511 19.7808 21.0778 18.1104 21.6698 15.8738C21.7796 15.4588 21.851 15.0342 21.8735 14.6029C21.8742 14.5903 21.8741 14.5774 21.874 14.5645C21.8736 14.5206 21.8732 14.4758 21.9032 14.4375V13.4062C21.8877 13.296 21.8724 13.1859 21.857 13.0758C21.8417 12.9657 21.8264 12.8556 21.8109 12.7454C21.6706 11.7417 21.3321 10.8079 20.8223 9.93417C20.4979 9.37833 20.1009 8.87917 19.6609 8.41042C18.512 7.18708 17.0904 6.46958 15.4635 6.1325C15.2051 6.07917 14.9421 6.04375 14.677 6.03125C14.6727 6.03103 14.6684 6.03086 14.664 6.03068C14.6268 6.02916 14.5891 6.02762 14.5588 6ZM20.4048 12.4633C20.513 12.9412 20.5697 13.4242 20.5656 13.8233C20.5706 16.5837 18.9382 18.9987 16.4592 19.9983C15.5307 20.3725 14.568 20.5487 13.5698 20.4958C12.4455 20.4362 11.4035 20.0958 10.445 19.5054C10.3627 19.4546 10.2938 19.4425 10.2003 19.4671C9.52492 19.6462 8.84843 19.8206 8.17187 19.995L8.02482 20.0329C7.82568 20.0842 7.82401 20.0817 7.8762 19.8925C7.91577 19.7497 7.9553 19.6069 7.99482 19.464C8.14959 18.9047 8.30438 18.3453 8.46234 17.7867C8.48865 17.6942 8.47988 17.6242 8.42561 17.5429C7.90709 16.7642 7.55766 15.9133 7.40737 14.9913C7.1694 13.5292 7.40444 12.1346 8.10289 10.83C8.95706 9.23375 10.2513 8.14875 11.9826 7.60583C12.782 7.355 13.6036 7.27083 14.4436 7.335C15.603 7.42375 16.67 7.77667 17.6277 8.43C19.0701 9.41417 20.0166 10.7479 20.4048 12.4633ZM14.8755 17.4629C15.2459 17.5908 15.6188 17.7196 16.0571 17.7046L16.0567 17.7042C16.5146 17.7321 16.9459 17.5496 17.355 17.2779C17.8393 16.9567 17.9587 16.4725 17.9888 15.9433C17.9971 15.7938 17.9182 15.6983 17.7834 15.625C17.7222 15.5919 17.6574 15.5779 17.5927 15.5639C17.5336 15.5512 17.4746 15.5385 17.4185 15.5113C17.3047 15.4561 17.1919 15.3987 17.0791 15.3412C16.7893 15.1936 16.4995 15.0459 16.1915 14.9379C15.9515 14.8538 15.8759 14.8863 15.7239 15.0813C15.5382 15.3192 15.3465 15.5521 15.1528 15.7833C15.0272 15.9333 14.9232 15.9538 14.7374 15.8808C13.571 15.4229 12.6817 14.64 12.0388 13.5708C11.9006 13.3413 11.9077 13.2783 12.0889 13.0763C12.2559 12.89 12.4125 12.6971 12.5398 12.48C12.6237 12.3371 12.6329 12.2042 12.5623 12.0529C12.4905 11.8986 12.4258 11.7409 12.361 11.5832C12.335 11.52 12.309 11.4568 12.2826 11.3938C12.2449 11.3036 12.2076 11.2132 12.1703 11.1229C12.0906 10.9302 12.011 10.7376 11.9278 10.5467C11.8714 10.4175 11.8038 10.28 11.6476 10.2563C11.4894 10.2321 11.3258 10.2271 11.1654 10.2329C10.9538 10.2408 10.7538 10.2983 10.601 10.4583C10.3355 10.7358 10.1297 11.0525 10.0015 11.4163C9.77482 12.0588 9.89589 12.6721 10.1652 13.2708C10.4146 13.8257 10.7886 14.2964 11.1638 14.7685L11.1667 14.7721C12.1102 15.9596 13.2253 16.9117 14.6911 17.4C14.7527 17.4205 14.814 17.4417 14.8755 17.4629Z"
            fill="white"
          />
        </svg>
      );
      break;

    case 'full-screen':
      icon = (
        <svg {...svgProps} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.654297" y="0.208984" width="32" height="32" rx="10" fill="#050000" fillOpacity="0.33" />
          <path
            d="M8.20703 8.16455V12.3507L9.55462 11.0031L12.9953 14.4438L14.4576 12.9528L11.0456 9.51214L12.3932 8.16455H8.20703ZM20.7368 8.16455L22.0844 9.51214L18.6437 12.9528L20.106 14.4438L23.5466 11.0031L24.8942 12.3507V8.16455H20.7368ZM12.9953 18.6012L9.55462 22.0419L8.20703 20.6943V24.8518H12.3932L11.0456 23.5042L14.4576 20.0922L12.9953 18.6012ZM20.106 18.6012L18.6437 20.0922L22.0844 23.5042L20.7368 24.8518H24.8942V20.6943L23.5466 22.0419L20.106 18.6012Z"
            fill="white"
          />
        </svg>
      );
      break;

    case 'close':
      icon = (
        <svg {...svgProps} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1098_232430)">
            <path
              d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
              fill="#053550"
            />
          </g>
          <defs>
            <clipPath id="clip0_1098_232430">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    case 'arrow-left':
      icon = (
        <svg {...svgProps} width="21" height="9" viewBox="0 0 21 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.75 0.169824L0.5 4.49995L5.75 8.83008L5.75 5.49995L20.5 5.49995L20.5 3.49995L5.75 3.49995L5.75 0.169824Z"
            fill="#053550"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.75 0.169824L0.5 4.49995L5.75 8.83008L5.75 5.49995L20.5 5.49995L20.5 3.49995L5.75 3.49995L5.75 0.169824Z"
            fill={secondaryColor || '#CDE7F4'}
          />
        </svg>
      );
      break;

    case 'blue-arrow-left':
      icon = (
        <svg {...svgProps} width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1694_49832)">
            <path
              d="M23.3466 5.66005L20.9733 3.30005L7.78662 16.5L20.9866 29.7L23.3466 27.34L12.5066 16.5L23.3466 5.66005Z"
              fill="#fff"
            />
          </g>
          <defs>
            <clipPath id="clip0_1694_49832">
              <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    case 'mark':
      icon = (
        <svg {...svgProps} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="#E6E6DB" fillOpacity="0.7" />
          <path
            d="M12.7091 25.3147L20.8985 33.2097L37.3985 16.7097"
            stroke="#053550"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;

    case 'blue-arrow-right':
      icon = (
        <svg {...svgProps} width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1694_49887)">
            <path
              d="M8.65338 27.34L11.0267 29.7L24.2134 16.5L11.0134 3.29995L8.65338 5.65995L19.4934 16.5L8.65338 27.34Z"
              fill="#fff"
            />
          </g>
          <defs>
            <clipPath id="clip0_1694_49887">
              <rect width="32" height="32" fill="white" transform="translate(32 32.5) rotate(180)" />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    case 'facebook':
      icon = (
        <svg {...svgProps} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.0976562" width="27.8048" height="27.8048" rx="10" fill="#245F80" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7426 22.1099H15.1465V14.0453H17.3106C17.419 14.0453 17.5097 13.9628 17.5189 13.8556L17.7271 11.422C17.737 11.3006 17.6411 11.1973 17.5182 11.1973H15.1465V9.47053C15.1465 9.06581 15.4783 8.73774 15.8876 8.73774H17.5557C17.6706 8.73774 17.7646 8.64484 17.7646 8.53116V6.09762C17.7646 5.98328 17.6706 5.89038 17.5557 5.89038H14.7372C13.0835 5.89038 11.7426 7.21564 11.7426 8.85143V11.1973H10.2506C10.135 11.1973 10.041 11.2902 10.041 11.4045V13.838C10.041 13.9524 10.135 14.0453 10.2506 14.0453H11.7426V14.1746V22.1099Z"
            fill="white"
          />
        </svg>
      );
      break;

    case 'email':
      icon = (
        <svg {...svgProps} width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.861328" y="0.0976562" width="27.8048" height="27.8048" rx="10" fill="#245F80" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.1971 12.4608V17.439C21.1971 18.1339 20.8995 18.464 20.254 18.464H9.34134C8.6958 18.464 8.39822 18.1339 8.39822 17.439V12.4799L7.04102 11.349V17.7895C7.04102 18.8911 7.92647 19.7929 9.00915 19.7929H20.52C21.6027 19.7929 22.4882 18.8911 22.4882 17.7895V11.3963L21.1971 12.4608ZM15.4124 13.66C14.9916 13.9037 14.5514 13.9006 14.1044 13.6511L9.45802 9.49126H20.1166L15.4124 13.66ZM13.2317 14.7809C13.2652 14.8109 13.3005 14.8369 13.3389 14.8598C13.8004 15.1373 14.2912 15.2757 14.7774 15.2757C15.2639 15.2757 15.7463 15.1373 16.1907 14.8598C16.2241 14.8392 16.2557 14.8159 16.2853 14.7895L21.5783 10.0995C21.5818 10.096 21.5844 10.0917 21.5886 10.0886L22.2523 9.51575C21.9649 8.75164 21.2651 8.20752 20.4482 8.20752H9.06736C8.26604 8.20752 7.57458 8.72988 7.27693 9.47144L8.19648 10.2729L13.2317 14.7809Z"
            fill="white"
          />
        </svg>
      );
      break;
    case 'twitter':
      icon = (
        <svg {...svgProps} width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.431641" y="0.0976562" width="27.8048" height="27.8048" rx="10" fill="#245F80" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1535 20.512C14.8023 20.512 17.0807 18.8232 18.3495 17.4065C19.9381 15.6326 20.8493 13.2863 20.8493 10.9693C20.8493 10.8191 20.846 10.6732 20.8396 10.5359C20.8347 10.4336 20.8826 10.3358 20.967 10.2758C21.345 10.0068 21.6365 9.73957 21.9487 9.40383C22.1412 9.07176 22.2194 8.65135 22.2298 8.45753C22.2403 8.2637 22.2184 7.7497 21.7614 8.03663C21.2784 8.24322 20.7746 8.3978 20.2557 8.49833C20.1515 8.51857 20.0439 8.48457 19.9712 8.40826C19.3664 7.7743 18.5129 7.4107 17.6295 7.4107C15.8605 7.4107 14.4213 8.82685 14.4213 10.5675C14.4213 10.8135 14.4492 11.0557 14.5043 11.2873C14.5265 11.3802 14.503 11.4779 14.4409 11.5511C14.3787 11.6244 14.2848 11.6643 14.1885 11.6598C11.4411 11.5239 8.8568 10.3019 7.02596 8.28836C6.86993 8.66525 6.7887 9.07041 6.7887 9.4803C6.7887 10.5387 7.32231 11.5212 8.21618 12.1083C8.33066 12.1836 8.3807 12.3244 8.33875 12.4534C8.2968 12.5825 8.1734 12.669 8.03547 12.6644C7.61113 12.6516 7.18925 12.5674 6.79233 12.418C6.98209 13.7233 7.99228 14.8027 9.33318 15.0671C9.47351 15.0948 9.57606 15.2138 9.58093 15.3546C9.58573 15.4953 9.49161 15.6208 9.35354 15.6578C8.9682 15.761 8.56957 15.8047 8.16702 15.786C8.69543 16.8212 9.77014 17.5022 10.9752 17.5242C11.1057 17.5266 11.2206 17.6096 11.262 17.7314C11.3035 17.8532 11.2625 17.9875 11.1597 18.0668C9.959 18.9927 8.53659 19.5191 7.02335 19.6014C8.31057 20.1998 9.71756 20.512 11.1535 20.512ZM5.59711 19.5168C5.47618 19.4405 5.4247 19.2921 5.47317 19.1588C5.52156 19.0257 5.65689 18.9426 5.79975 18.9597C6.0619 18.9901 6.33193 19.0055 6.60237 19.0055C7.86992 19.0055 9.07837 18.6695 10.1389 18.0277C8.859 17.7249 7.80424 16.7863 7.39094 15.5168C7.35769 15.4147 7.38161 15.303 7.4538 15.2228C7.52599 15.1426 7.63581 15.1059 7.74275 15.1259C7.80397 15.1375 7.86532 15.1472 7.92675 15.1553C6.84498 14.4806 6.14313 13.2904 6.14313 11.9721C6.14313 11.9514 6.14327 11.9317 6.14437 11.9121C6.14992 11.8074 6.2099 11.713 6.30307 11.6623C6.39623 11.6116 6.50934 11.6117 6.60237 11.6626C6.7392 11.7376 6.88159 11.8024 7.02795 11.8566C6.48048 11.1942 6.17172 10.3592 6.17172 9.4803C6.17172 8.81585 6.35085 8.16158 6.68978 7.58822C6.74071 7.50213 6.83134 7.44606 6.93225 7.43823C7.03295 7.43054 7.1316 7.4719 7.19556 7.54915C8.8457 9.54176 11.247 10.7952 13.8321 11.0265C13.8136 10.8753 13.8043 10.722 13.8043 10.5675C13.8043 8.49206 15.5203 6.80347 17.6295 6.80347C18.624 6.80347 19.5865 7.18994 20.2977 7.8693C20.9923 7.71729 21.6554 7.45861 22.2715 7.09933C22.3816 7.03496 22.5207 7.0444 22.621 7.12301C22.7212 7.20161 22.828 7.31501 22.9032 7.46805C22.9783 7.62109 23.006 7.70445 23.0215 8.17231C23.037 8.64016 22.8278 9.16309 22.7666 9.28143C22.6084 9.58721 22.1252 10.1765 21.4621 10.6707C21.4649 10.7677 21.4662 10.8676 21.4662 10.9693C21.4662 13.4321 20.499 15.9248 18.8123 17.808C17.4595 19.3186 15.0326 21.1193 11.1535 21.1193C9.18058 21.1193 7.25918 20.5651 5.59711 19.5168Z"
            fill="white"
            stroke="white"
            strokeWidth="0.772357"
          />
        </svg>
      );
      break;
    default:
      break;
  }

  return (
    <i className={classNames(css.icon, className)} {...iconProps}>
      {icon}
    </i>
  );
};

Icon.defaultProps = {
  className: '',
  width: 38.945,
  height: 38.948,
  color: '#111',
  secondaryColor: '',
};

export default Icon;
